// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AProposRouteImport } from './routes/a-propos'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AmenagementProfessionnelHotellerieRouteImport } from './routes/amenagement-professionnel-hotellerie'
import { Route as ArchitecteInterieurBrindasRouteImport } from './routes/architecte-interieur-brindas'
import { Route as ArchitecteInterieurCaluireEtCuireRouteImport } from './routes/architecte-interieur-caluire-et-cuire'
import { Route as ArchitecteInterieurCharbonnieresLesBainsRouteImport } from './routes/architecte-interieur-charbonnieres-les-bains'
import { Route as ArchitecteInterieurCraponneRouteImport } from './routes/architecte-interieur-craponne'
import { Route as ArchitecteInterieurDardillyRouteImport } from './routes/architecte-interieur-dardilly'
import { Route as ArchitecteInterieurEcullyRouteImport } from './routes/architecte-interieur-ecully'
import { Route as ArchitecteInterieurLyonRouteImport } from './routes/architecte-interieur-lyon'
import { Route as ArchitecteInterieurLyon2RouteImport } from './routes/architecte-interieur-lyon-2'
import { Route as ArchitecteInterieurLyon6RouteImport } from './routes/architecte-interieur-lyon-6'
import { Route as ArchitecteInterieurOullinsRouteImport } from './routes/architecte-interieur-oullins'
import { Route as ArchitecteInterieurSainteFoyLesLyonRouteImport } from './routes/architecte-interieur-sainte-foy-les-lyon'
import { Route as ArchitecteInterieurTassinLaDemiLuneRouteImport } from './routes/architecte-interieur-tassin-la-demi-lune'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DecorationInterieureLyonRouteImport } from './routes/decoration-interieure-lyon'
import { Route as Images3dVisualisationArchitecturaleRouteImport } from './routes/images-3d-visualisation-architecturale'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as PolitiqueDeConfidentialiteRouteImport } from './routes/politique-de-confidentialite'
import { Route as PrestationsRouteImport } from './routes/prestations'
import { Route as ProjetsRouteImport } from './routes/projets'
import { Route as RenovationInterieureLyonRouteImport } from './routes/renovation-interieure-lyon'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminBlogRouteImport } from './routes/admin.blog'
import { Route as AdminEmailsRouteImport } from './routes/admin.emails'
import { Route as AdminErreursRouteImport } from './routes/admin.erreurs'
import { Route as AdminFaqRouteImport } from './routes/admin.faq'
import { Route as AdminMessagesRouteImport } from './routes/admin.messages'
import { Route as AdminNewsletterRouteImport } from './routes/admin.newsletter'
import { Route as AdminParametresRouteImport } from './routes/admin.parametres'
import { Route as AdminProjetsRouteImport } from './routes/admin.projets'
import { Route as AdminTemoignagesRouteImport } from './routes/admin.temoignages'
import { Route as AdminLoginRouteImport } from './routes/admin_.login'
import { Route as BlogSlugRouteImport } from './routes/blog_.$slug'
import { Route as ProjetsSlugRouteImport } from './routes/projets_.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AProposRoute = AProposRouteImport.update({
            id: '/a-propos',path: '/a-propos',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AmenagementProfessionnelHotellerieRoute = AmenagementProfessionnelHotellerieRouteImport.update({
            id: '/amenagement-professionnel-hotellerie',path: '/amenagement-professionnel-hotellerie',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurBrindasRoute = ArchitecteInterieurBrindasRouteImport.update({
            id: '/architecte-interieur-brindas',path: '/architecte-interieur-brindas',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurCaluireEtCuireRoute = ArchitecteInterieurCaluireEtCuireRouteImport.update({
            id: '/architecte-interieur-caluire-et-cuire',path: '/architecte-interieur-caluire-et-cuire',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurCharbonnieresLesBainsRoute = ArchitecteInterieurCharbonnieresLesBainsRouteImport.update({
            id: '/architecte-interieur-charbonnieres-les-bains',path: '/architecte-interieur-charbonnieres-les-bains',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurCraponneRoute = ArchitecteInterieurCraponneRouteImport.update({
            id: '/architecte-interieur-craponne',path: '/architecte-interieur-craponne',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurDardillyRoute = ArchitecteInterieurDardillyRouteImport.update({
            id: '/architecte-interieur-dardilly',path: '/architecte-interieur-dardilly',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurEcullyRoute = ArchitecteInterieurEcullyRouteImport.update({
            id: '/architecte-interieur-ecully',path: '/architecte-interieur-ecully',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurLyonRoute = ArchitecteInterieurLyonRouteImport.update({
            id: '/architecte-interieur-lyon',path: '/architecte-interieur-lyon',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurLyon2Route = ArchitecteInterieurLyon2RouteImport.update({
            id: '/architecte-interieur-lyon-2',path: '/architecte-interieur-lyon-2',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurLyon6Route = ArchitecteInterieurLyon6RouteImport.update({
            id: '/architecte-interieur-lyon-6',path: '/architecte-interieur-lyon-6',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurOullinsRoute = ArchitecteInterieurOullinsRouteImport.update({
            id: '/architecte-interieur-oullins',path: '/architecte-interieur-oullins',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurSainteFoyLesLyonRoute = ArchitecteInterieurSainteFoyLesLyonRouteImport.update({
            id: '/architecte-interieur-sainte-foy-les-lyon',path: '/architecte-interieur-sainte-foy-les-lyon',getParentRoute: () => rootRouteImport
          })
const ArchitecteInterieurTassinLaDemiLuneRoute = ArchitecteInterieurTassinLaDemiLuneRouteImport.update({
            id: '/architecte-interieur-tassin-la-demi-lune',path: '/architecte-interieur-tassin-la-demi-lune',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DecorationInterieureLyonRoute = DecorationInterieureLyonRouteImport.update({
            id: '/decoration-interieure-lyon',path: '/decoration-interieure-lyon',getParentRoute: () => rootRouteImport
          })
const Images3dVisualisationArchitecturaleRoute = Images3dVisualisationArchitecturaleRouteImport.update({
            id: '/images-3d-visualisation-architecturale',path: '/images-3d-visualisation-architecturale',getParentRoute: () => rootRouteImport
          })
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => rootRouteImport
          })
const PolitiqueDeConfidentialiteRoute = PolitiqueDeConfidentialiteRouteImport.update({
            id: '/politique-de-confidentialite',path: '/politique-de-confidentialite',getParentRoute: () => rootRouteImport
          })
const PrestationsRoute = PrestationsRouteImport.update({
            id: '/prestations',path: '/prestations',getParentRoute: () => rootRouteImport
          })
const ProjetsRoute = ProjetsRouteImport.update({
            id: '/projets',path: '/projets',getParentRoute: () => rootRouteImport
          })
const RenovationInterieureLyonRoute = RenovationInterieureLyonRouteImport.update({
            id: '/renovation-interieure-lyon',path: '/renovation-interieure-lyon',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRoute
          })
const AdminBlogRoute = AdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AdminRoute
          })
const AdminEmailsRoute = AdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AdminRoute
          })
const AdminErreursRoute = AdminErreursRouteImport.update({
            id: '/erreurs',path: '/erreurs',getParentRoute: () => AdminRoute
          })
const AdminFaqRoute = AdminFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => AdminRoute
          })
const AdminMessagesRoute = AdminMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AdminRoute
          })
const AdminNewsletterRoute = AdminNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => AdminRoute
          })
const AdminParametresRoute = AdminParametresRouteImport.update({
            id: '/parametres',path: '/parametres',getParentRoute: () => AdminRoute
          })
const AdminProjetsRoute = AdminProjetsRouteImport.update({
            id: '/projets',path: '/projets',getParentRoute: () => AdminRoute
          })
const AdminTemoignagesRoute = AdminTemoignagesRouteImport.update({
            id: '/temoignages',path: '/temoignages',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin_/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog_/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ProjetsSlugRoute = ProjetsSlugRouteImport.update({
            id: '/projets_/$slug',path: '/projets/$slug',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,AdminBlogRoute: AdminBlogRoute,AdminEmailsRoute: AdminEmailsRoute,AdminErreursRoute: AdminErreursRoute,AdminFaqRoute: AdminFaqRoute,AdminMessagesRoute: AdminMessagesRoute,AdminNewsletterRoute: AdminNewsletterRoute,AdminParametresRoute: AdminParametresRoute,AdminProjetsRoute: AdminProjetsRoute,AdminTemoignagesRoute: AdminTemoignagesRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AProposRoute: AProposRoute,AdminRoute: AdminRouteWithChildren,AmenagementProfessionnelHotellerieRoute: AmenagementProfessionnelHotellerieRoute,ArchitecteInterieurBrindasRoute: ArchitecteInterieurBrindasRoute,ArchitecteInterieurCaluireEtCuireRoute: ArchitecteInterieurCaluireEtCuireRoute,ArchitecteInterieurCharbonnieresLesBainsRoute: ArchitecteInterieurCharbonnieresLesBainsRoute,ArchitecteInterieurCraponneRoute: ArchitecteInterieurCraponneRoute,ArchitecteInterieurDardillyRoute: ArchitecteInterieurDardillyRoute,ArchitecteInterieurEcullyRoute: ArchitecteInterieurEcullyRoute,ArchitecteInterieurLyonRoute: ArchitecteInterieurLyonRoute,ArchitecteInterieurLyon2Route: ArchitecteInterieurLyon2Route,ArchitecteInterieurLyon6Route: ArchitecteInterieurLyon6Route,ArchitecteInterieurOullinsRoute: ArchitecteInterieurOullinsRoute,ArchitecteInterieurSainteFoyLesLyonRoute: ArchitecteInterieurSainteFoyLesLyonRoute,ArchitecteInterieurTassinLaDemiLuneRoute: ArchitecteInterieurTassinLaDemiLuneRoute,BlogRoute: BlogRoute,ContactRoute: ContactRoute,DecorationInterieureLyonRoute: DecorationInterieureLyonRoute,Images3dVisualisationArchitecturaleRoute: Images3dVisualisationArchitecturaleRoute,MentionsLegalesRoute: MentionsLegalesRoute,PolitiqueDeConfidentialiteRoute: PolitiqueDeConfidentialiteRoute,PrestationsRoute: PrestationsRoute,ProjetsRoute: ProjetsRoute,RenovationInterieureLyonRoute: RenovationInterieureLyonRoute,AdminLoginRoute: AdminLoginRoute,BlogSlugRoute: BlogSlugRoute,ProjetsSlugRoute: ProjetsSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)